import { useTranslation } from 'react-i18next';
import { type Me, memberDisplayName, memberInitial, ROLE_LABEL_KEYS } from '@/entities/session';
import { LogoMark } from '@/shared/ui';
import { ProfileMenu } from './ProfileMenu';
import { SidebarNav } from './SidebarNav';

export interface SidebarProps {
  brandName: string;
  /** Загруженный «Логотип платформы»; нет — знак дизайн-системы. */
  logoUrl?: string | null;
  me: Me;
  onChangePassword: () => void;
}

/**
 * Сайдбар (README §1): ширина 240, фон gold-wash, правая граница inset -1px gold-soft.
 * Бренд — знак 32×32, название Display 18/21, подпись «Админ-панель»; низ — аватар 28, имя, роль.
 */
export function Sidebar({ brandName, logoUrl, me, onChangePassword }: SidebarProps) {
  const { t } = useTranslation('shell');
  const { t: tCommon } = useTranslation();
  return (
    <aside className="relative flex w-240 shrink-0 flex-col overflow-hidden bg-sidebar shadow-[inset_-1px_0_0_var(--vw-gold-soft)]">
      <div className="flex items-center gap-12 px-16 pt-20 pb-16">
        <LogoMark size={32} src={logoUrl} />
        <div className="flex flex-col gap-2">
          <span className="font-display text-[18px] leading-[21px] text-ink-900">{brandName}</span>
          <span className="text-[10px] font-medium tracking-[0.1em] text-gold-leaf-3 uppercase">
            {t('brand.subtitle')}
          </span>
        </div>
      </div>

      <SidebarNav nav={me.nav} />

      <div className="flex items-center gap-10 border-t border-gold-soft py-12 pr-12 pl-16">
        <span
          aria-hidden="true"
          className="flex size-28 shrink-0 items-center justify-center rounded-pill bg-wine-bordeaux font-display text-[13px] text-ink-inverse-pure"
        >
          {memberInitial(me)}
        </span>
        <div className="flex min-w-0 flex-1 flex-col">
          <span className="truncate text-[12px] font-medium text-ink-900">
            {memberDisplayName(me)}
          </span>
          <span className="text-[11px] text-gold-leaf-3">
            {tCommon(ROLE_LABEL_KEYS[me.member.role])}
          </span>
        </div>
        <ProfileMenu onChangePassword={onChangePassword} />
      </div>
    </aside>
  );
}
